import React, { useEffect, useState } from "react";
import Illustration from "../../../../partials/content/Illustration";
import NumberFormat from "react-number-format";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import { getOutletSalesReport } from "../../../../services/sales/salesReportService";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";

function OutletSalesReport(props) {
  const { reload } = useGlobalData();
  const [outletSales, setOutletSales] = useState([]);

  useEffect(() => {
    getOutletSalesData();
  }, [reload]);

  const top5SalesItemsColumn = [
    {
      header: "Item Type",
      field: "itemTypeName",
      body: (rowData) => (
        <React.Fragment>
          <ResponsiveEllipsis text={rowData.itemTypeName} maxLine="1" />
        </React.Fragment>
      ),
      sortable: true,
      filter: true,
      hidden: true,
    },
    {
      header: "Item Code",
      field: "itemCode",
      body: (rowData) => (
        <React.Fragment>
          {rowData.itemType > 0 ? (
            <span>
              <BootstrapTooltip title={rowData.itemTypeName}>
                <span className="mr-2">
                  <i
                    className={
                      rowData.itemType === 1
                        ? "fas fa-boxes text-success"
                        : rowData.itemType === 2
                        ? "fas fa-tools text-primary"
                        : rowData.itemType === 3
                        ? "fas fa-building text-info"
                        : rowData.itemType === 4
                        ? "fas fa-boxes text-warning"
                        : rowData.itemType === 5
                        ? "fas fa-boxes text-danger"
                        : null
                    }
                  ></i>
                </span>
              </BootstrapTooltip>
              <span>
                <ResponsiveEllipsis
                  text={rowData.itemCode}
                  maxLine="1"
                  displayInline
                />
              </span>
            </span>
          ) : (
            <React.Fragment>
              <ResponsiveEllipsis text={rowData.itemCode} maxLine="1" />
            </React.Fragment>
          )}
        </React.Fragment>
      ),
      sortable: true,
      filter: true,
    },
    {
      header: "Item Name",
      field: "itemName",
      body: (rowData) => (
        <React.Fragment>
          <ResponsiveEllipsis text={rowData.itemName} maxLine="1" />
        </React.Fragment>
      ),
      sortable: true,
      filter: true,
    },
    {
      header: "Quantity",
      field: "qty",
      body: (rowData) => (
        <div>
          {rowData.qty} {rowData.uomName}
        </div>
      ),
      sortable: true,
      filter: true,
    },
    {
      header: "Unit",
      field: "uomName",
      body: null,
      sortable: true,
      filter: true,
      hidden: true,
    },
    {
      header: "Sales Count",
      field: "salesCount",
      body: null,
      sortable: true,
      filter: true,
    },
    {
      header: "Sales Amount",
      field: "salesAmount",
      body: (rowData) => (
        <NumberFormat
          value={rowData.salesAmount}
          displayType={"text"}
          thousandSeparator={true}
          decimalScale={2}
          renderText={(value) => (
            <div className="float-right">
              {rowData.currencyCode} {value}
            </div>
          )}
        />
      ),
      sortable: true,
      filter: true,
    },
  ];

  return (
    <React.Fragment>
      {outletSales.length ? (
        <React.Fragment>
          <CustomDataTable
            data={outletSales}
            dataDetailName="salesItem"
            dataDetailColumns={top5SalesItemsColumn}
            dataDetailTitle="Top 5 Sales Items"
            onRefreshData={() => {
              getOutletSalesData();
            }}
            columns={[
              {
                header: "Outlet Name",
                field: "outletName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.outletName} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "City",
                field: "city",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.city} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Sales Count",
                field: "salesCount",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Sales Amount",
                field: "salesAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.salesAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Average Sales",
                field: "averageSales",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.averageSales}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Cost of Goods Sold",
                field: "cogs",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.cogs}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Net Profit",
                field: "netProfit",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.netProfit}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Sales.png"
            description="You don't have any Outlet Sales data yet"
            guidance="Hint: once the Outlet is created, it will be displayed here"
            descriptionLeftIcon="fas fa-info-circle kt-font-info"
            size="md"
          ></Illustration>
        </React.Fragment>
      )}
    </React.Fragment>
  );

  async function getOutletSalesData() {
    const response = await getOutletSalesReport();
    const { data } = response.data;
    setOutletSales(data.outletSalesReport);
  }
}

export default OutletSalesReport;
